import { redirect } from "@tanstack/react-router";
import type { ParsedLocation } from "@tanstack/react-router";
import type { RouterContext } from "@/routes/__root.tsx";
import type { Role } from "@/types/api/types.ts";
import { ROLE_SUPER_ADMIN } from "@/constants";

type BeforeLoadArgs = {
  context: RouterContext;
  location: ParsedLocation;
};

export const requireRole = (requiredRoles: Role[]) => {
  return ({ context, location }: BeforeLoadArgs) => {
    const isAuthenticated = context.session?.isAuthenticated;
    const userRole = context.session?.user?.role;

    // Not authenticated -> redirect to login
    if (!isAuthenticated || !userRole) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }

    const isSuperAdmin = userRole === ROLE_SUPER_ADMIN;
    const hasRequiredRole = requiredRoles.includes(userRole);

    // Authenticated but wrong role -> redirect to unauthorized
    if (!isSuperAdmin && !hasRequiredRole) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }
  };
};
